import Tree from '../pyramid-builder/pyramid-renderer.view.js';

export default class TreeDiagramRenderer {

  constructor(questions, scheme, zoom, mouseWheelZoom) {
    this.scheme = scheme || [];
    this.questionFlag = questions;
    this.zoom = zoom;
    this.mouseWheelZoom = mouseWheelZoom;
    this.options = {
      xAxisOffset: 50,
      yAxisOffset: 120,
      droppable: true
    };
  }

  destroy() {
    this.children.length = 0;
    this.destroySVG();
  }

  getByModel(model) {
    return this.children.find((leaf) => leaf.model === model);
  }

  setModelAt(i, model) {
    if (this.children[i]) {
      this.children[i].model = model;
    }
  }

  render() {
    if (!this.scheme || this.scheme.length < 1) return;

    this.tree = new Tree({
      duration: 1000,
      rectangle: {
        recWidth: 165,
        recHeight: 110,
        spaceBetweenRecX: 70,
        spaceBetweenRecY: 280
      },
      zoom: this.zoom,
      mouseWheelZoom: this.mouseWheelZoom,
      questionsEnabled: this.questionFlag,
      clickHandler: this.onSelectItem,
      zoomHandler: this.onZoom
    });
    this.tree.init(this.scheme);
    this.scheme = this.tree.treeScheme;
  }

  /**
   * Callback handler
   */
  onSelectItem() {
  }

  onMouseWheel() {
  }
}



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/tree-renderer.view.js